import { Label } from "@/components/ui/label";

export function Card({ children }) {
  return <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-6">{children}</div>;
}

export function SectionHeader({ title, action }) {
  return (
    <div className="flex items-center justify-between mb-6">
      <h2 className="font-heading font-extrabold text-2xl text-slate-900">{title}</h2>
      {action}
    </div>
  );
}

export function PrimaryBtn({ children, className = "", ...props }) {
  return (
    <button {...props} className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-sky-500 text-white font-bold hover:bg-sky-600 transition-colors disabled:opacity-60 ${className}`}>
      {children}
    </button>
  );
}

export function IconBtn({ icon: Icon, onClick, color = "slate", testid }) {
  const c = { slate: "text-slate-500 hover:bg-slate-100", rose: "text-rose-500 hover:bg-rose-50", sky: "text-sky-600 hover:bg-sky-50", emerald: "text-emerald-600 hover:bg-emerald-50" }[color];
  return (
    <button onClick={onClick} data-testid={testid} className={`grid place-items-center w-9 h-9 rounded-full transition-colors ${c}`}>
      <Icon className="w-4 h-4" />
    </button>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <Label>{label}</Label>
      {children}
    </div>
  );
}
